import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)
// in development env not use Lazy Loading,because Lazy Loading too many pages will cause webpack hot update too slow.so only in production use Lazy Loading

/*   */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
export const constantRouterMap = [
  { path: '/404', component: _import('404'), hidden: true },
  // 首页默认跳转
  // {
  //     path: '/',
  //     component: Layout,
  //     redirect: '/description/index',
  //     name: 'description',
  //     hidden: true,
  //     children: [{ path: 'index', component: _import(newFunction()) }]
  // },
  // {
  //     path: '/description',
  //     component: Layout,
  //     redirect: '/description/index',
  //     icon: 'description',
  //     noDropdown: true,
  //     children: [{ path: 'index', name: '说明补充', component: _import('description/description') }]
  // },
  // 收缩菜单
  // {
  //     path: '/store',
  //     component: Layout,
  //     redirect: 'noredirect',
  //     name: '足浴酒店',
  //     icon: 'store',
  //     children: [
  //         { path: 'storeMGR', name: '足浴酒店-门店管理', component: _import('store/storeMGR') },
  //         { path: 'agentMGR', name: '足浴酒店-合作商表', component: _import('agent/agentMGR') },
  //     ]
  // },

  // {
  //     path: '/',
  //     component: Layout,
  //     redirect: '/storeMGR/index',
  //     name: 'storeMGR',
  //     icon: 'store',
  //     hidden: true,
  //     children: [{ path: 'index', component: _import("store/storeMGR") }]
  // },
  // // 单列菜单
  // {
  //     path: '/storeMGR',
  //     component: Layout,
  //     redirect: '/storeMGR/index',
  //     icon: 'store',
  //     noDropdown: true,
  //     beforeEnter: (to, from, next) => {
  //         if ((navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  //             // window.location.href="你的手机版地址";
  //             next("/storeMgrPhone");
  //         } else {
  //             next();
  //         }
  //         // ...
  //     },
  //     children: [
  // { path: 'index', name: '门店管理', component: _import('store/storeMGR') },
  // { path: 'advertisement', name: '广告管理',hidden: true, component: _import('store/advertisement') },
  // { path: 'details/:id', name: '门店详情', hidden: true, component: _import('store/details')},
  // { path: 'addStore', name: '申请建店', hidden: true, component: _import('store/addStore')},
  // { path: 'addDemoStore', name: '新增演示门店', hidden: true, component: _import('store/addDemoStore')},
  // { path: 'previewApplyStore/:id', name: '门店信息', hidden: true, component: _import('store/previewApplyStore')},
  // { path: 'editStore/:id', name: '编辑门店', hidden: true, component: _import('store/editStore')},
  //     ]
  // },

  // 移动端门店管理
  {
    path: '/storeMgrPhone',
    component: Layout,
    redirect: '/storeMgrPhone/index',
    icon: 'store',
    noDropdown: true,
    hidden: true,
    children: [{ path: 'index', name: '门店管理wap', component: _import('store/phone') }]
  },
  // 移动端门店序列号编辑
  {
    path: '/phoneEdit',
    component: Layout,
    redirect: '/phoneEdit/index',
    icon: 'store',
    noDropdown: true,
    hidden: true,
    children: [{ path: 'index', name: '门店管理序列号编辑wap', component: _import('store/phone_edit') }]
  },
  // {
  //     path: '/serialNumberMgt',
  //     component: Layout,
  //     redirect: 'noredirect',
  //     name: '序列号',
  //     icon: 'store',
  //     children: [
  //         { path: 'lists', name: '序列号列表', component: _import('serialNumberMgt/serialNumber') },
  //         { path: 'active', name: '激活序列号', component: _import('serialNumberMgt/activeNumber') },
  //     ]
  // },

  // {
  //     path: '/serialNumberMgt',
  //     component: Layout,
  //     redirect: '/serialNumberMgt/index',
  //     icon: 'icons',
  //     noDropdown: true,
  //     children: [{ path: 'index', name: 'PSN管理', component: _import('serialNumberMgt/serialNumber') }]
  // },

  // {
  //     path: '/agentMGR',
  //     component: Layout,
  //     redirect: '/agentMGR/index',
  //     icon: 'agent',
  //     noDropdown: true,
  //     children: [{ path: 'index', name: '合作商', component: _import('agent/agentMGR') }]
  // },

  // 路径错误，默认跳转地址
  {
    path: '*',
    component: Layout,
    redirect: '/store/storeMGR',
    name: 'storeMGR*',
    hidden: true
  },
  {
    path: '/store',
    component: Layout,
    name: '门店管理',
    icon: 'store',
    meta: { permission: 'agent_store_manage' },
    children: [
      { path: 'storeMGR', name: '门店管理', component: _import('store/storeMGR'), meta: { permission: 'agent_store' } },
      { path: 'advertisement', name: '广告管理', hidden: true, component: _import('store/advertisement') },
      { path: 'details/:id', name: '门店详情', hidden: true, component: _import('store/details') },
      { path: 'addStore', name: '申请建店', hidden: true, component: _import('store/addStore') },
      { path: 'addDemoStore', name: '新增演示门店', hidden: true, component: _import('store/addDemoStore') },
      { path: 'previewApplyStore/:id', name: '门店信息', hidden: true, component: _import('store/previewApplyStore') },
      { path: 'editStore/:id', name: '编辑门店', hidden: true, component: _import('store/editStore') },
      { path: 'examine', name: '内容审核', component: _import('store/examine'), hidden: true },
      { path: 'roleManagement', name: '角色管理', component: _import('store/roleManagement/index'), meta: { permission: 'agent_store1' } },
      { path: 'staffManagement', name: '员工管理', component: _import('store/staffManagement/index'), meta: { permission: 'agent_store2' } }
    ]
  },
  {
    path: '/memberManagement',
    component: Layout,
    icon: 'lease',
    name: '会员管理',
    meta: { permission: 'agent_member_manage' },
    children: [
      {
        path: 'qnFilm',
        name: '青柠电影',
        component: _import('memberManagement/qnFilm'),
        meta: { permission: 'agent_member_manage_qnFilm' }
      },
      {
        path: 'qnFilmMember',
        name: '青柠电影',
        component: _import('memberManagement/qnFilmMember/index'),
        meta: { permission: 'agent_member_manage_qnFilm_tv' }
      },
      {
        path: 'mango',
        name: '芒果TV',
        component: _import('memberManagement/mango/index'),
        meta: { permission: 'agent_member_manage_mangoTV' }
      },
      {
        path: 'memberWorkOrder',
        name: '会员工单',
        component: _import('memberManagement/memberWorkOrder'),
        meta: { permission: 'agent_member_manage_workorder' }
      },
      {
        path: '/memberManagement/authorization',
        name: '授权书',
        redirect: 'memberManagement/authorization/authorizationInApplication',
        noDropdown: true,
        component: _import('memberManagement/authorization'),
        meta: { permission: 'agent_member_manage_authorization' },
        children: [
          {
            path: 'authorizationComplete',
            name: '申请成功',
            component: _import('memberManagement/authorizationComplete'),
          },
          {
            path: 'authorizationInApplication',
            name: '申请中',
            component: _import('memberManagement/authorizationInApplication'),
          }
        ]
      }
    ]
  },
  {
    path: '/EquipmentManagement',
    component: Layout,
    name: '设备管理',
    icon: 'store',
    meta: { permission: 'agent_device_manage' },
    children: [
      {
        path: 'serialNumberMgts',
        component: _import('EquipmentManagement/serialNumber/index'),
        name: 'PSN管理',
        meta: { permission: 'agent_device_manage_psn' }
      },
      // {
      //   path: 'PsnUsing',
      //   component: _import('EquipmentManagement/PSNUsings/index'),
      //   name: 'PSN使用'
      // },
      {
        path: '/monitoringManagement',
        component: _import("EquipmentManagement/index"),
        name: '监测管理',
        meta: { permission: 'agent_device_manage_monitoring' },
        children: [
          {
            name: '温度监测',
            path: '/EquipmentManagement/monitoringManagement',
            noDropdown: true,
            component: _import('EquipmentManagement/monitoringManagement/index'),
            redirect: '/EquipmentManagement/monitoringManagement/highTemperatureEquipment',
            meta: { permission: 'agent_device_manage_monitoring_temperature' },
            children: [
              {
                path: 'highTemperatureEquipment',
                component: _import('EquipmentManagement/monitoringManagement/highTemperatureEquipment'),
                hidden: true,
                name: '高温设备',
              },
              {
                path: 'temperatureLog',
                component: _import('EquipmentManagement/monitoringManagement/temperatureLog'),
                name: '高温设备 / 高温日志'
              },
              {
                path: 'temperatureDetails',
                component: _import('EquipmentManagement/monitoringManagement/temperatureDetails'),
                name: '高温设备 / 高温详情'
              },
              {
                path: 'temperatureLogAll',
                component: _import('EquipmentManagement/monitoringManagement/temperatureLogAll'),
                hidden: true,
                name: '高温日志'
              },
              {
                path: 'handleLog',
                component: _import('EquipmentManagement/monitoringManagement/handleLog'),
                hidden: true,
                name: '处理日志'
              },
            ]
          },
          {
            path: 'PsnUsing',
            component: _import('EquipmentManagement/PSNUsings/index'),
            name: '使用监测',
            meta: { permission: 'agent_device_manage_monitoring_area' }
          },
        ]
      }
    ]
  },
  {
    path: '/filmManagement',
    component: Layout,
    // redirect: 'filmManagement/MovieBlacklist',
    name: '电影管理',
    icon: 'lease',
    meta: { permission: 'agent_film_manage' },

    children: [
      {
        path: 'MovieBlacklist',
        component: _import('filmManagement/movieBlacklist'),
        name: '电影黑名单',
        meta: { permission: 'agent_film_manage_backlist' }

      },
      {
        path: 'MovieWhitelist',
        component: _import('filmManagement/movieWhitelist'),
        name: '电影白名单',
        meta: { permission: 'agent_film_manage_whitelist' }

      },
      // {
      //   path: 'device',
      //   component: _import('filmManagement/device/index'),
      //   name: '青柠电影设备'
      // },
      // {
      //   path: 'mangoVip',
      //   component: _import('filmManagement/mangoVip/index'),
      //   name: '芒果TV会员'
      // }
      /* {
          path: 'ServerManagement',
          component: _import('filmManagement/serverManagement'),
          name: '服务器管理',
      },
      {
        path: 'ServerManagement/:sn',
        component: _import('filmManagement/download'),
        name: '服务器管理 / 电影下载',
        hidden: true,
      } */
    ]
  },
  {
    path: '/updateManagement',
    component: Layout,
    // redirect: 'filmManagement/MovieBlacklist',
    name: '更新管理',
    icon: 'lease',
    meta: { permission: 'agent_update_manage' },

    children: [
      {
        path: 'GeneralSoftware',
        component: _import('updateManagement/generalSoftware'),
        name: '通用软件',
        meta: { permission: 'agent_general_software_server_software' }
      },
      {
        path: 'GeneralSoftware/:sn/:id',
        component: _import('updateManagement/softwareStoreManagement'),
        name: '通用软件 / 门店管理',
        hidden: true
      },
      {
        path: 'appDetails',
        component: _import('updateManagement/appDetails'),
        name: '通用软件 / 门店管理',
        hidden: true
      }
    ]
  },
  {
    path: '/leaseManagement',
    component: Layout,
    // redirect: '/agent/agentMGR',
    name: '租赁管理',
    icon: 'lease',
    meta: { permission: 'agent_lease_manage' },

    children: [
      {
        path: '/lease',
        component: _import('leaseManagement/index'),
        name: '租赁管理1',
        meta: { permission: 'agent_lease_manage_one' },

        children: [
          {
            path: 'leaseAddInfo',
            component: _import('leaseManagement/lease/leaseAddInfo'),
            name: '租赁信息添加',
            meta: { permission: 'agent_lease_manage_one_list' }
          },
          {
            path: 'leaseInfoCheck',
            component: _import('leaseManagement/lease/leaseInfoCheck'),
            name: '租赁数据查看',
            hidden: true
          },
          {
            path: 'deviceInfo',
            component: _import('leaseManagement/lease/deviceInfo'),
            name: '租赁数据查看 / 租赁设备信息',
            hidden: true
          }
        ]
      },
      {
        path: '/lease2',
        component: _import('leaseManagement/index'),
        name: '租赁管理2',
        meta: { permission: 'agent_lease_manage_two' },

        children: [
          {
            path: 'hotel',
            component: _import('leaseManagement/lease2/hotel/index'),
            name: '租赁门店',
            meta: { permission: 'agent_lease_manage_two_store' }
          },
          {
            path: 'device',
            component: _import('leaseManagement/lease2/device/index'),
            name: '租赁设备',
            meta: { permission: 'agent_lease_manage_two_device' }
          },
          {
            path: 'payRecord',
            component: _import('leaseManagement/lease2/payRecord/index'),
            name: '购买记录',
            meta: { permission: 'agent_lease_manage_two_purchase_record' }
          },
          {
            path: 'disbuteRecords',
            component: _import('leaseManagement/lease2/disbuteRecords/index'),
            name: '分发记录',
            meta: { permission: 'agent_lease_manage_two_distribution_record' }
          },
          {
            path: 'useRecord',
            component: _import('leaseManagement/lease2/useRecord/index'),
            name: '使用详情',
            meta: { permission: 'agent_lease_manage_two_usage_record' }
          },
          {
            path: 'useDetailList/:id',
            component: _import('leaseManagement/lease2/useDetailList/index'),
            name: '使用详情 / 详情',
            hidden: true
          }
        ]
      },
      {
        path: '/lease3',
        component: _import('leaseManagement/index'),
        name: '租赁管理3',
        meta: { permission: 'agent_lease_manage_three' },

        children: [
          {
            path: 'openStore',
            component: _import('leaseManagement/lease3/openStore'),
            name: '开通门店',
            meta: { permission: 'agent_lease_manage_three_open_store' }
          },
          {
            path: 'dataStatistics',
            component: _import('leaseManagement/lease3/dataStatistics'),
            name: '数据统计',
            meta: { permission: 'agent_lease_manage_three_report' }
          },
          {
            path: 'dataStatisticsDetails',
            component: _import('leaseManagement/lease3/dataStatisticsDetails'),
            name: '数据统计 / 查看',
            hidden: true
          }
        ]
      },
    ]
  },
  {
    path: '/gameManager',
    component: Layout,
    name: '游戏管理',
    icon: 'tubiao',
    meta: { permission: 'agent_game_manage' },
    children: [
      {
        path: 'flowOrder',
        component: _import('gameManager/flowOrder'),
        name: '订单管理',
        meta: { permission: 'agent_game_order_manage' }
      }
    ]
  },
  {
    path: '/settle',
    component: Layout,
    redirect: '/settle/recordList',
    icon: 'tubiao',
    noDropdown: true,
    hidden: true,
    children: [
      {
        path: 'recordList',
        name: '结算详情',
        component: _import('settle/recordList/index'),
        hidden: true
      },
      {
        path: 'orderList/:id',
        name: '结算详情 / 订单',
        component: _import('settle/orderList/index'),
        hidden: true
      }
    ]
  },
  {
    path: '/helpCenter',
    component: Layout,
    icon: 'helpCenter',
    name: '帮助中心',
    meta: { permission: 'agent_support_enter' },
    children: [
      {
        path: 'sharedFiles',
        name: '共享文件',
        component: _import('helpCenter/shareFiles/index'),
        meta: { permission: 'agent_support_enter_shared_files' }
      },
      {
        path: 'techDocument',
        name: '共享文件 / 技术文档',
        component: _import('helpCenter/techDocument/index'),
        hidden: true
      }
    ]
  },
  {
    path: '/afterSalesManage',
    component: Layout,
    icon: 'helpCenter',
    name: '售后管理',
    meta: { permission: 'agent_after_sales_manage' },
    children: [
      {
        path: 'exchangeGoods',
        name: '售后换货',
        component: _import('afterSalesManage/exchange/index'),
        meta: { permission: 'agent_after_sales_exchange' }
      },
      {
        path: 'exchangeDetails',
        name: '售后换货 / 详情',
        component: _import('afterSalesManage/exchange/details'),
        hidden: true
      },
      // {
      //   path: 'repairOrder',
      //   name: '维修工单',
      //   component: _import('afterSalesManage/repairOrder/index'),
      //   meta: 'repair_order'
      // },
      {
        path: 'ReturnVisitService',
        name: '回访记录',
        component: _import('afterSalesManage/ReturnVisitService/index'),
        meta: { permission: 'agent_return_visit_record' }

      },
      // {
      //   path: 'repairOrderAdd',
      //   name: '维修工单 / 新增维修',
      //   component: _import('afterSalesManage/repairOrder/addMaintenance'),
      //   hidden: true
      // },
      // {
      //   path: 'repairOrderDetail',
      //   name: '维修工单 / 工单详情',
      //   component: _import('afterSalesManage/repairOrder/detailOrder'),
      //   hidden: true
      // },
      {
        path: 'NewReturnVisi',
        name: '回访记录 / 新增回访',
        component: _import('afterSalesManage/NewReturnVisi/index'),
        hidden: true
      },
      {
        path: 'ReturnVisitDetails',
        name: '回访记录 / 回访详情',
        component: _import('afterSalesManage/ReturnVisitDetails/index'),
        hidden: true
      },
      {
        path: 'BorrowMachineSystem',
        name: '借机系统',
        component: _import('afterSalesManage/BorrowMachineSystem/index'),
        meta: { permission: 'agent_borrowing_machine_manage' }

      },
      {
        path: 'BorrowMachinePact',
        name: '借机协议',
        component: _import('afterSalesManage/BorrowMachineSystem/BorrowMachinePact/index'),
        hidden: true
      },
      {
        path: 'AddApplication',
        name: '借机服务',
        component: _import('afterSalesManage/BorrowMachineSystem/AddApplication'),
        hidden: true
      },
      {
        path: 'PaymentTransfer',
        name: '借机服务 ',
        component: _import('afterSalesManage/BorrowMachineSystem/PaymentTransfer'),
        hidden: true
      },
      {
        path: 'ThroughDetails',
        name: '借机详情',
        component: _import('afterSalesManage/BorrowMachineSystem/BorrworderDetails/index'),
        hidden: true
      },
      {
        path: 'ReturnEquipment',
        name: '借机服务 / 归还设备',
        component: _import('afterSalesManage/BorrowMachineSystem/ReturnEquipmentOperation/index'),
        hidden: true
      },
      {
        path: 'afterSalesMaintenance',
        name: '售后维修',
        component: _import('afterSalesManage/afterSalesMaintenance/index'),
        meta: { permission: 'agent_after_sales_maintenance' }

      },
      {
        path: 'MaintenanceDetails/:id',
        name: '售后维修 / 维修详情',
        component: _import('afterSalesManage/afterSalesMaintenance/MaintenanceDetails/index'),
        hidden: true
      }
    ]
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js